<template>
    <div>
        <div class="banner">
            <div class="swiper-wrapper">
                <div class="swiper-slide"><img src="@/assets/goyb02.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb03.png" alt="" /></div>
                <div class="swiper-slide"><img src="@/assets/goyb01.png" alt="" /></div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->

            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
        <!-- <div class="main1">
            <div class="title1">技能培训</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/01.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__bounceInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/training/02.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" style="background: #ededed;">
        <div class="section-title">技能培训</div>
        <div class="dual-card">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="../../assets/training/01.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/02.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            🛠️ 聚焦岗位实操与专业进阶，提升员工业务能力与工作效率。
        </div>
    </div>
        <!-- <div class="main2">
            <div class="title1">安全培训</div>
            <div class="content3">
                <div class="img3 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/06-1.jpg" alt="">
                </div>
                <div class="img3 wow animate__animated animate__bounceInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/training/07.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" >
        <div class="section-title">安全培训</div>
        <div class="dual-card">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="../../assets/training/06-1.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/07.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            ⚠️ 强化安全意识与规范操作，预防事故风险，保障生产与食品安全。
        </div>
    </div>
        <!-- <div class="main3">
            <div class="title1">礼仪培训</div>
            <div class="content3">
                <div class="img3 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/15.jpg" alt="">
                </div>
                <div class="img3 wow animate__animated animate__bounceInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/training/13.jpg" alt="">
                </div>
                <div class="img3 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/10.jpg" alt="">
                </div>
                <div class="img3 wow animate__animated animate__bounceInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/training/14.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" style="background: #ededed;">
        <div class="section-title">礼仪培训</div>
        <div class="dual-card">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="../../assets/training/15.jpg" alt="">
            </div>
            <!-- <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/13.jpg" alt="">
            </div> -->
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/10.jpg" alt="">
            </div>
            <!-- <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/14.jpg" alt="">
            </div> -->
        </div>
        <div class="section-footer-text">
            💼 塑造职业形象与服务礼仪，提升客户满意度与企业品牌。
        </div>
    </div>

        <!-- <div class="main2">
            <div class="title1">消防演练</div>
            <div class="content1">
                <div class="img1 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/03.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__bounceInLeft animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s" style="margin-top: 100px;">
                    <img src="../../assets/training/04.jpg" alt="">
                </div>
                <div class="img1 wow animate__animated animate__bounceInRight animate__delay-1s animate__slower animate__repeat-1 " data-wow-duration="1s" data-wow-delay="0.5s" data-wow-iteration="1s">
                    <img src="../../assets/training/05.jpg" alt="">
                </div>
            </div>
        </div> -->
        <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" >
        <div class="section-title">消防演练</div>
        <div class="dual-card" >
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="../../assets/training/03.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/04.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/05.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/05-1.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            🔥 模拟火灾应急响应，掌握灭火与疏散技能，筑牢生命安全防线。
        </div>
    </div>
    <div class="section wow animate__animated animate__fadeInUp" data-wow-duration="1s" style="background: #ededed;">
        <div class="section-title">急救培训</div>
        <div class="dual-card" style="grid-template-columns: repeat(3, 1fr);">
            <div class="gallery-img wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                <img src="../../assets/training/16.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/17.jpg" alt="">
            </div>
            <div class="gallery-img wow animate__animated animate__fadeInRight" data-wow-delay="0.4s">
                <img src="../../assets/training/18.jpg" alt="">
            </div>
        </div>
        <div class="section-footer-text">
            🩺 掌握急救知识与技能，筑牢生命防线，守护员工与客户安全。
        </div>
    </div>

    </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from 'wowjs'
export default {
    mounted() {
    //第一种写法，可以设置wow中属性
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
    var wow = new WOW({
        boxClass: 'wow',///动画元件css类（默认为wow）
        animateClass: 'animated',//动画css类（默认为animated） 
        offset: 0,//到元素距离触发动画（当默认为0） 
        mobile: true, //在移动设备上触发动画（默认为true） 
        live: true//对异步加载的内容进行操作（默认为true）
    })
    wow.init()
    }),
    new Swiper(".banner",{
        loop:true, //循环模式选项

        // 如果需要分页器
        pagination:{
            el:".swiper-pagination",
        },
        // 如果需要前进后退按钮
        navigation:{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // 如果需要滚动条
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },

      autoplay: {
        autoplay: true, // 自动切换
        disableOnInteraction: false, // 点击之后重新计算
      },
    });
},
}
</script>

<style scoped>
.banner{
    width: 100%;
    height: 3.5rem;
    overflow: hidden;
}
/* .banner:hover img{
    transform: scale(1.2);
} */
.banner img{
    /* transition: all .4s; */
    width: 100%;
    height: 100%;
    /* display: block;
    object-fit: cover; */
}
.main1,
.main2{
    width: 100%;
    /* height: 3rem; */
    background-color: #ededed;
    /* margin: 20px auto; */
}
.title1{
    font-size: .1rem;
    font-weight: 700;
    padding: 20px 0;
}
.content1{
    width: 70%;
    /* height: 2.66rem; */
    margin: 0 auto;
    display: flex;
    /* background-color: green; */
    flex-wrap: wrap;
}
.img1,.img2{
    width: 50%;
    height: 375px;
}
img{
    width: 100%;
    height: 100%;
}
.text1{
    width: 50%;
    /* height: 2.66rem; */
    /* background-color: yellow; */
}
/* 第二部分 */
.main2{
    background-color: #fff;
}
.content2{
    width: 60%;
    /* height: 2.6rem; */
    margin: 0 auto;
}
/* 第三部分 */
.main3{
    width: 100%;
    /* height: 2.85rem; */
    background-color: #ededed;
}
.img3{
    width: 50%;
    height: 375px;
}
.content3{
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
}

.section {
            /* max-width: 1280px;
            margin: 0 auto;
            padding: 60px 24px; */

                padding: 0.3125rem 0.125rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
        }
        .section-title {
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            margin-bottom: 48px;
            position: relative;
            letter-spacing: 2px;
        }
        .section-title:after {
            content: '';
            display: block;
            width: 80px;
            height: 4px;
            background: linear-gradient(90deg, #f97316, #facc15);
            margin: 16px auto 0;
            border-radius: 4px;
        }
        /* 网格布局（左右交替卡片） */
        .gallery-grid {
            display: flex;
            flex-direction: column;
            gap: 48px;
        }
        .gallery-row {
            display: flex;
            gap: 30px;
            align-items: center;
            background: #ffffff;
            border-radius: 32px;
            box-shadow: 0 20px 35px -12px rgba(0,0,0,0.1);
            overflow: hidden;
            transition: all 0.3s;
        }
        .gallery-row:hover {
            transform: translateY(-6px);
            box-shadow: 0 25px 40px -12px rgba(0,0,0,0.15);
        }
        .gallery-img {
            flex: 1;
            overflow: hidden;
            max-height: 350px;
        }
        .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1);
            display: block;
        }
        .gallery-row:hover .gallery-img img {
            transform: scale(1.05);
        }
        .gallery-desc {
            flex: 1;
            padding: 24px 32px;
        }
        .gallery-desc h3 {
            font-size: 24px;
            margin-bottom: 12px;
            color: #f97316;
        }
        .gallery-desc p {
            font-size: 16px;
            color: #475569;
            line-height: 1.6;
        }
        /* 交替方向 */
        .gallery-row.reverse {
            flex-direction: row-reverse;
        }
        /* 员工体检双卡片 */
        .dual-card {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
        }
        .dual-card .gallery-img {
            max-height: 380px;
            border-radius: 24px;
            overflow: hidden;
            box-shadow: 0 15px 25px -8px rgba(0,0,0,0.1);
        }
        .dual-card .gallery-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.4s;
        }
        .dual-card .gallery-img:hover img {
            transform: scale(1.03);
        }
        .section-footer-text {
            text-align: center;
            margin-top: 32px;
            color: #475569;
            font-size: 18px;
            padding: 0 20px;
        }
</style>